import React, { useState } from 'react'
import BackhoeLoaderWhyChooseRippa from './BackhoeLoaderWhyChooseRippa'
import BackhoeLoaderWhyChooseHengwang from './BackhoeLoaderWhyChooseHengwang'
import BackhoeLoaderCardComponentRippa from './BackhoeLoaderCardComponentRippa'
import BackhoeLoaderCardComponentHengwang from './BackhoeLoaderCardComponentHengwang'

const BackhoeLoaderTabSection = () => {
  const [activeTab, setActiveTab] = useState('Rippa');

  return (
    <section className='pt-4 sm:pt-16'>
        <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
            <div className='flex flex-row items-center gap-4 sm:gap-6 lg:gap-8 py-10 border-b-2 border-black'>
                <button
                  onClick={() => setActiveTab('Rippa')}
                  className={`outline-none text-3xl leading-normal font-semibold transition-colors duration-200 ${
                    activeTab === 'Rippa' ? 'text-black' : 'text-gray-400'
                  }`}
                >
                  Rippa
                </button>
                <span className='text-3xl font-normal text-slate-300'>|</span>
                <button
                  onClick={() => setActiveTab('Hengwang')}
                  className={`outline-none text-3xl leading-normal font-semibold transition-colors duration-200 ${
                    activeTab === 'Hengwang' ? 'text-black' : 'text-gray-400'
                  }`}
                >
                  HengWang
                </button>
            </div>

            {activeTab === 'Rippa' && (
                <div className='rippa-section'>
                <BackhoeLoaderWhyChooseRippa />
                <section className="py-8 sm:py-16 bg-white">
              <div className="max-w-7xl mx-auto">
                <div className="mb-8 lg:mb-12">
              <h2 className="text-4xl sm:text-3xl lg:text-4xl xl:text-5xl font-normal text-gray-900 mb-2">What's<span className="font-bold"> Special</span> about<span className="font-bold"> Rippa</span>?</h2>
            </div>
                <BackhoeLoaderCardComponentRippa />
                              </div>
            </section>
                </div>
            )}

            {activeTab === 'Hengwang' && (
                <div className='henwang-section'>
                <BackhoeLoaderWhyChooseHengwang />
                <section className="py-8 sm:py-16 bg-white">
              <div className="max-w-7xl mx-auto">
                <div className="mb-8 lg:mb-12">
              <h2 className="text-4xl sm:text-3xl lg:text-4xl xl:text-5xl font-normal text-gray-900 mb-2">What's<span className="font-bold"> Special</span> about<span className="font-bold"> HengWang</span>?</h2>
            </div>
                <BackhoeLoaderCardComponentHengwang />
                </div>
                </section>
                </div>
            )}
        </div>
    </section>
  )
}

export default BackhoeLoaderTabSection